import {FAVICON_REQUEST_SIZE, FAVICON_SERVICE_URL} from './web-source-favicon.types';

/**
 * A cited site's favicon through Google's favicon service, so the viewer's browser never contacts the cited
 * site itself. The domain is already a validated DNS host (backend `WebSource::fromCitation` + the
 * registration's link-host check).
 */
export function getFaviconUrl(domain: string): string {
  const url = new URL(FAVICON_SERVICE_URL);
  url.searchParams.set('domain', domain);
  url.searchParams.set('sz', String(FAVICON_REQUEST_SIZE));

  return url.toString();
}
